export const CREATE_NEW_OPTION_VALUE = 0;
